import { ProvideCreate } from "@/di/provide_create";
import { PageService } from "@/services/page";
import { ChannelStateManager } from "@/state/channel";
import { Subscribe } from "@/utils/subscribe";

import type { ChannelState } from "@/state/channel";

@ProvideCreate({
  sxhr: PageService,
})
class Channel {
  sxhr!: PageService;

  private static instance: Channel | null = null;
  // 事件系统
  private $channelSubject = new Subscribe<{
    end: ChannelState;
    change: ChannelState;
  }>();

  public $end = this.$channelSubject.replay("end");
  public $change = this.$channelSubject.replay("change");

  private stateManager!: ChannelStateManager;
  private constructor() {
    // 初始化配置
    this.initializeConfig();
  }

  static create(): Channel {
    if (!Channel.instance) {
      Channel.instance = new Channel();
    }
    return Channel.instance;
  }

  private initializeConfig(): void {
    this.stateManager = new ChannelStateManager();

    // 订阅状态变化
    this.stateManager.subscribe((state) => {
      this.$channelSubject.emit("change", state);
    });
  }

  // 获取当前状态快照
  get snapshot(): Readonly<ChannelState> {
    return this.stateManager.snapshot;
  }

  // 状态更新方法
  setState(
    update:
      | Partial<ChannelState>
      | ((prev: ChannelState) => Partial<ChannelState>),
    options?: { emitEvent?: boolean; deepCompare?: boolean },
  ): void {
    this.stateManager.setState(update, options);
  }

  // 订阅状态变化
  subscribe(listener: (state: ChannelState) => void): () => void {
    return this.stateManager.subscribe(listener);
  }

  async init(id: string): Promise<void> {
    void this.sxhr.channel(id).then((res) => {
      res.embed.forEach((d) => {
        const result = {
          embed_icon: d.embed_icon,
          embed_title: d.embed_title,
          type: d.type,
          position: d.position,
          x: d.x,
          y: d.y,
          icon_color: d.icon_color,
        };
        if (d.equipment === "pc") {
          this.setState({
            pc: result,
          });
        } else if (d.equipment == "m") {
          this.setState({
            wap: result,
          });
        }
      });
      this.setState({ icon: res.basic.icon });
      this.setEnd();
    });
  }

  setEnd(): void {
    this.$channelSubject.emit("end", this.snapshot);
  }
}

export const $channel = Channel.create();
export { Channel };
